import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalisationService } from '@app/services/localisation.service';
import { QuestionnaireService } from '@app/services/questionnaire.service';

@Component({
  selector: 'app-review-questions',
  templateUrl: './review-questions.component.html',
  styleUrls: ['./review-questions.component.scss']
})
export class ReviewQuestionsComponent implements OnInit {
  static route: string = 'review-questions';

  locale: any = {};

  constructor(
    private router: Router,
    private questionnaireService: QuestionnaireService,
    private localalisation: LocalisationService
  ) {}

  ngOnInit() {
    this.locale = this.localalisation.getTranslationsForComponent('ReviewQuestionsComponent');
    this.questionnaireService.getQuestionnaireStatus().subscribe();
  }

  seeMyResults() {
    this.router.navigate([`/centigrade/course-areas`]);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/questionnaire/review-questions/review-questions.component.ts